<template>
  <!-- eslint-disable max-len vue/max-len -->
  <section class="privacy-page small-scroll-bar small-scroll-bar--black">
    <school-new-breadcrumbs
      :breadcrumbs="breadcrumbs"
      :borders="false"
    />

    <for-static-text>
      <h1>Согласие на&nbsp;обработку персональных&nbsp;данных</h1>

      <p>
        Оставляя контактные данные в форме на сайте и нажимая на кнопку «ОК» настоящим я, в соответствии со&nbsp;статьей&nbsp;9&nbsp;Федерального закона от 27.07.2006 N 152-ФЗ «О персональных данных», в целях:<br>
        - обеспечения соблюдения требований законов и иных нормативных правовых актов,<br>
        - заключения гражданско-правовых договоров,<br>
        - получения информационных рассылок,<br>
        - статистических и иных целях,<br>
        <span>даю согласие&nbsp;ИПК «Арсенал»</span> (далее – Оператору),&nbsp;<span>на</span>&nbsp;автоматизированную, а также без использования средств автоматизации&nbsp;<span>обработку моих персональных данных</span>, а именно совершение действий, предусмотренных&nbsp;пунктом 3 статьи 3&nbsp;ФЗ РФ № 152-ФЗ «О персональных данных», а именно: сбор, систематизацию, накопление, хранение, уточнение (обновление, изменение), использование, распространение (в том числе передачу третьим лицам), обезличивание, блокирование, уничтожение персональных данных.
        <br>
        Обработка персональных данных может осуществляться как с использованием средств автоматизации, так и без их использования (на бумажных носителях).
        <br>
        Разрешаю обмен (прием, передачу, обработку) моих персональными данных между оператором и третьими лицами в соответствии с заключенными договорами и соглашениями, в целях соблюдения моих законных прав и интересов.
        <br>
        <br>
        <br>
        Перечень&nbsp;моих персональных данных, на обработку которых я даю согласие:<br>
        - фамилия, имя, отчество;<br>
        - пол, возраст, дата рождения;<br>
        - номера телефонов (домашний, мобильный), адресов электронной почты, иные реквизиты для связи;<br>
        - сведения об изменении всех указанных выше данных.
        <br>
        <br>
        <br>
        Настоящее согласие действует до дня его отзыва в письменной форме.
        Согласие на обработку персональных данных (полностью или частично) может быть отозвано мной на основании моего письменного заявления.
      </p>
    </for-static-text>
  </section>
</template>

<script>
import HeadMixin from '~/mixins/HeadMixin';
import SchoolNewBreadcrumbs from '../../components/v2/school-new/SchoolNewBreadcrumbs.vue';
import ForStaticText from '../../components/v2/common/ForStaticText.vue';

export default {
  name: 'PrivacyArsenal',
  components: {
    ForStaticText,
    SchoolNewBreadcrumbs,
  },
  mixins: [HeadMixin],
  layout: 'DefaultLayoutV2',
  scrollToTop: true,
  data: () => ({
    breadcrumbs: [
      { text: 'главная', to: '/' },
      { text: 'политика конфиденциальности ИПК&nbsp;АРСЕНАЛ', to: '/privacy' },
    ],

    // для head
    title: 'Политика обработки персональных данных | АНО ДПО ИПК «АРСЕНАЛ»',
    description: 'Политика обработки персональных данных | АНО ДПО ИПК «АРСЕНАЛ»',
    image: '/pages/arsenal-privacy-share-image.jpg',
    canonical: true,
  }),
};
</script>

<style scoped lang="scss">
.privacy-page {
  padding-top: calc(var(--scale) * 110);
  padding-bottom: calc(var(--scale) * 128);
  padding-inline: calc(var(--scale) * 40);
  background-color: #ECEDF0;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  gap: calc(var(--scale) * 20);

  font-family: 'Onest', sans-serif;

  @include media-down($size-tablet) {
    padding-inline: calc(var(--scale) * 16);
    padding-bottom: calc(var(--scale) * 80);
    gap: calc(var(--scale) * 10);
  }

  @include media-down($size-mobile) {
    padding-inline: calc(var(--scale) * 12);
  }

  ::v-deep(*) {
    font-family: "Onest", sans-serif;
  }

  h1 {
    margin-bottom: calc(var(--scale) * 32);

    @include media-down($size-tablet) {
      margin-bottom: calc(var(--scale) * 20);
    }
  }

  br {
    display: block;
    content: '';
    padding-top: calc(var(--scale) * 10);

    @include media-down($size-tablet) {
      padding-top: calc(var(--scale) * 8);
    }
  }
}

</style>
